<template>
  <div class="main">
    <div class="gong_neng">
      <el-button @click="goPage">返回</el-button>
    </div>
    <div id="echa" style="width:80%;height:300px;"></div>
  </div>
</template>

<script>
import { require } from '@/utils/http_request.js'
export default {
  data() {
    return {}
  },

  mounted() {
    console.log(this)
    // this.$route.query.name 为0 是企业的折线统计图 为1 则是精英版的折线统计图
    let url = ''
    if (this.$route.query.name == 'true') {
      console.log(typeof this.$route.query.name)

      url = '/hr24_index_data/v1/month_day_detail_elite/'
    } else {
      if (this.$cookies.get('auth_grade') == 90) {
        url = '/hr24_index_data/v1/province_agent_month_day_detail/'
      } else {
        url = '/hr24_index_data/v1/month_day_detail/'
      }
    }
    let obj = {
      show_data: this.$route.query.src,
    }
    require('post', url, obj).then((res) => {
      if (!res.code) {
        if (this.$route.query.name) {
          this.showLine(res.data, res.time_list)
        } else {
          let mon_data = res.data.splice(',').map((item) => {
            console.log(item)
            return item
          })
          this.showLine(mon_data, res.time_list)
        }
      }
    })
  },

  methods: {
    goPage() {
      this.$router.go(-1)
    },
    showLine(mon_data, day) {
      var myChart = this.$echarts.init(document.getElementById('echa'))
      var title = this.$route.query.title
      myChart.setOption({
        title: {
          text: title,
          textStyle: {
            fontSize: 14,
            fontWeight: 'normal',
          },
        },
        legend: {
          data: ['数量'],
        },
        xAxis: {
          data: day,
        },
        yAxis: {},
        label: {},
        tooltip: {},
        series: [{ name: '数量', type: 'line', data: mon_data }],
      })
    },
  },
}
</script>

<style scoped>
.main {
  margin-top: 46px;
  margin-left: 229px;
  background: #ffff;
  width: 80vw;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
  padding: 50px;
}
.gong_neng {
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/index/line_ech.vue